import { Media } from './models/Media';
import { Fulfillment } from './models/Fulfillment';
import { Identifiers } from './models/Identifiers';
import { Info } from './models/Info';
import { AvailabilityType } from './models/AvailabilityType';
import { Product } from './models/Product';
import { Query } from './models/Query';

const resolvers = {
  Media,
  Fulfillment,
  Identifiers,
  Info,
  AvailabilityType,
  BaseProduct: Product,
  FbrProduct: Product,
  CollectionProduct: Product,
  DynamicRecsProduct: Product,
  Query,
};

export default resolvers;
